import { EpicRefined } from 'interfaces/middleware'
import { AdvisorMeetingActions, GetAdvisorTimeslotsAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { mergeMap, map, delay } from 'rxjs/operators'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { GET_ADVISOR_TIMESLOTS_PUBLIC_URL } from 'interfaces/ajax'
import { of, zip } from 'rxjs'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { SEARCH_ADVISOR_DURATION } from 'components/features/coaching/advisorMeeting/types/constants'

export const getAdvisorTimeslotsEpic: EpicRefined<AdvisorMeetingActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetAdvisorTimeslotsAction.type),
  mergeMap((action) => {
    const { params } = action.payload
    const { advisor_uid } = params

    const request$ = (() => {
      return get({ url: GET_ADVISOR_TIMESLOTS_PUBLIC_URL, params: { advisor_uid }})
    })()

    return zip(
      of(null).pipe(delay(SEARCH_ADVISOR_DURATION)),
      request$
    ).pipe(
      map((event) => event[1]),
      map(({ response }) => {
        const { results, ...pagination } = response

        return action.success({
          timeslots: { [advisor_uid]: results },
          timeslotsPagination: {
            [advisor_uid]: {
              ...pagination,
              results: [],
            },
          },
        })
      }),
      ajaxCatch((error) => {
        return of(action.fail({ errorCode: error.status }))
      }),
    )
  })
)
